import { Component, Inject, OnInit, QueryList, Self, ViewChild, ViewChildren } from '@angular/core';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { HttpClient } from '@angular/common/http';
import { DestroyService } from '../../../services/destroyservice';
import { MatDialog } from '@angular/material/dialog';
import { EmtTdcDeploymentStatusPopup } from '../emttdcdeployment/emttdc-deploymentstatus-popup.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MandatoryVersionUpdateComponent } from './mandatoryversionupdate/mandatoryversionupdate.component';
import { EquipmentManagenementService } from 'src/app/services/equipmentmanagement.service';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'fieldsettings',
    templateUrl: './fieldsettings.component.html',
    styleUrls: ['./fieldsettings.component.less', '../../../style/new-generic-styles.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class FieldSettingsComponent implements OnInit {
    subscriptionStage: any;
    @ViewChildren(MatTab)
    tabs!: QueryList<MatTab>;
    @ViewChild('tabGroup')
    tabGroup!: MatTabGroup;
    availableLanguages: Language[] = [];

    public availableFamilyCodes: FamilyCode[] = [];
    public familyCodes: Map<number, { familyCode: string; familyCodeName: string }> = new Map();

    @ViewChild(MandatoryVersionUpdateComponent)
    private mandatoryVersionUpdatecomponent!: MandatoryVersionUpdateComponent;

    constructor(private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , @Self() private readonly destroy$: DestroyService
        , private matDialog: MatDialog
        , private emtService: EquipmentManagenementService,
    ) { }

    ngOnInit(): void {
        this.getFamilyCodes();
        this.defaults.stageMessageChanges$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.getFamilyCodes();
            });
    }

    openDeploymentInformationPopup() {
        this.matDialog.open(EmtTdcDeploymentStatusPopup, {
            panelClass: 'custom-mat-dialog',
            data: { "component": 'emttdc' }
        });
    }

    private getFamilyCodes() {
        // Call to get family codes
        this.emtService.getFamilyCodes().pipe(
            takeUntil(this.destroy$)
        ).subscribe((response: ComponentFamilyCodes) => {
            this.availableFamilyCodes = response.familyCodeList;
            this.familyCodes = new Map(
                this.availableFamilyCodes.map(x => [
                    x.familyCodeId,
                    { familyCode: x.familyCode, familyCodeName: x.familyCodeName }
                ])
            );
        });
    }

    // As levels are just being created from Software Release To Field, we need to refresh the levels and list when a new software release is added.
    onSoftwareReleaseListSaved() {
        this.mandatoryVersionUpdatecomponent.loadAll()
        this.mandatoryVersionUpdatecomponent.levels.loadLevels();
        this.mandatoryVersionUpdatecomponent.list.clearForm();
    }
}
